import { MapFelterFn, TFelt, TFormRequest, TSektion } from './livsHistorie.definition';

const isString = value => typeof value === 'string';
const isNumber = value => typeof value === 'number';

const convertValuesToSingleObject = (payload, selector = 'value') => {
	const keys = Object.keys(payload);

	return keys.reduce((pre, cur) => {
		if (!payload[cur]) {
			return pre;
		}

		if (isString(payload[cur]) || isNumber(payload[cur])){
			return { ...pre, [cur]: payload[cur] };
		}

		return {
			...pre,
			[cur]: payload[cur][selector]
		};
	}, {});
};

const generateDefaultValues = (sektioner: TSektion[]) => {
	/** Foerst map over sektioner */
	return sektioner.reduce((pre, sek) => {
		return {
			...pre, // gem de forrige sektioner
			/* map over hver sektions felter */
			...sek.felter.reduce((pre, felt) => {

				if (felt.type === 'text') {
					return pre;
				}

				/* og returner et object med key: defaultValue */
				if (felt.type === 'input') {

					/* vi skal saette hele objektet som {label, value} */
					if (felt.inputType === 'dropdown') {
						return {
							...pre,
							[felt.name]: felt.options.find(f => f.value === felt.defaultValue) || ''

						};
					}

					return {
						...pre,
						[felt.name]: felt.defaultValue || ''
					};
				}
			}, {}) }; // en sektions felter
	}, {}); // sektioner bliver loopet igennem
};

const generateInitialSelected = (sektioner: TSektion[]) => {
	const selected = [];
	sektioner.forEach(sektion => {
		const { felter } = sektion;
		felter.forEach((felt:TFelt) => {
			const { type } = felt;

			if (type === 'input') {
				const { inputType } = felt;

				if (inputType === 'dropdown') {
					const { options, feltId, defaultValue } = felt;

					if (options && options.length > 0) {
						const relations = [];
						options
							.filter(option => option.visFelter && option.visFelter.length > 0)
							.forEach(option => {
								option.visFelter.map(feltId => {
									if (!relations.includes(feltId)) {
										relations.push(feltId);
									}
								});
							});

						const selectData = {
							selectId: feltId,
							relations: relations.length > 0 ? relations : null,
							visIds: null
						};

						const preSelected = options.some(option => option.value === defaultValue);

						if (preSelected) {
							options.forEach(option => {
								const { visFelter, value } = option;

								if (value === defaultValue) {
									selectData.visIds = visFelter;
									selected.push(selectData);
								}
							});
						} else {
							selected.push(selectData);
						}
					}
				}
			}
		});
	});

	return selected;
};


const mapFelter: MapFelterFn = (payload) => Object.keys(payload).map(key => ({
	feltId: key,
	feltValue: payload[key]
}));

const mapToLivshistorieEndpoint = (felter: TFormRequest['felter'], livsHistorieId: TFormRequest['livsHistorieId']): TFormRequest => ({
	livsHistorieId,
	felter
});

const mapLivsHistorie = (payload, id) => mapToLivshistorieEndpoint(mapFelter(payload), id);


export {
	isNumber,
	isString,
	generateDefaultValues,
	generateInitialSelected,
	convertValuesToSingleObject,
	mapLivsHistorie
};